"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getCurrentEnv", {
  enumerable: true,
  get: function get() {
    return _getCurrentEnv.getCurrentEnv;
  }
});
Object.defineProperty(exports, "EBDomains", {
  enumerable: true,
  get: function get() {
    return _types.EBDomains;
  }
});
Object.defineProperty(exports, "EBEnvs", {
  enumerable: true,
  get: function get() {
    return _types.EBEnvs;
  }
});

var _getCurrentEnv = require("./get-current-env");

var _types = require("./types");
//# sourceMappingURL=index.js.map